import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "content mb-4" }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = { class: "fs-3 bg-light rounded d-flex align-items-center p-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "mas mas-fill-1 me-2" }, "description", -1)
const _hoisted_5 = { class: "row row-title-menu" }
const _hoisted_6 = { class: "col-6" }
const _hoisted_7 = { class: "col-6" }
const _hoisted_8 = { class: "fs-4 d-flex align-items-center mt-4 mb-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "mas mas-fill-1 me-2" }, "fast_rewind", -1)
const _hoisted_10 = { class: "row row-before" }
const _hoisted_11 = { class: "col-8" }
const _hoisted_12 = { class: "fs-4 d-flex align-items-center mt-5 mb-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "mas mas-fill-1 me-2" }, "timelapse", -1)
const _hoisted_14 = { class: "row row-during mb-3" }
const _hoisted_15 = { class: "col-8" }
const _hoisted_16 = { class: "col-4" }
const _hoisted_17 = { class: "fs-4 d-flex align-items-center mt-5 mb-3" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "mas mas-fill-1 me-2" }, "fast_forward", -1)
const _hoisted_19 = { class: "row row-after" }
const _hoisted_20 = { class: "col-8" }
const _hoisted_21 = { class: "fs-4 d-flex align-items-center mt-5 mb-3" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "mas mas-fill-1 me-2" }, "subject", -1)
const _hoisted_23 = { class: "row row-extensive-explanation" }
const _hoisted_24 = { class: "col-12" }
const _hoisted_25 = { class: "mt-5 mb-3" }
const _hoisted_26 = { class: "fs-4 d-flex align-items-center" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "mas mas-fill-1 me-2" }, "event_upcoming", -1)
const _hoisted_28 = { class: "row row-notification-description mb-3" }
const _hoisted_29 = { class: "col" }
const _hoisted_30 = { class: "col" }
const _hoisted_31 = { class: "row row-external-url" }
const _hoisted_32 = { class: "col-12" }
const _hoisted_33 = { class: "d-inline-block mt-4" }
const _hoisted_34 = {
  type: "submit",
  class: "btn btn-primary"
}
const _hoisted_35 = {
  key: 0,
  class: "spinner-border spinner-border-sm ms-2",
  role: "status",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_alert_warning = _resolveComponent("alert-warning")!
  const _component_alert_info = _resolveComponent("alert-info")!
  const _component_input_text = _resolveComponent("input-text")!
  const _component_input_text_editor = _resolveComponent("input-text-editor")!
  const _component_input_url = _resolveComponent("input-url")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_dp_form = _resolveComponent("dp-form")!

  return (_openBlock(), _createBlock(_component_dp_form, {
    as: "form",
    onSubmit: _ctx.submitData,
    novalidate: ""
  }, {
    default: _withCtx(({ errors }) => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("header", _hoisted_2, [
          (_ctx.reservationCampaign.status_code === 'NEW')
            ? (_openBlock(), _createBlock(_component_alert_warning, {
                key: 0,
                message: _ctx.$t('warningReservationCampaignInactive')
              }, null, 8, ["message"]))
            : _createCommentVNode("", true),
          _createElementVNode("h2", _hoisted_3, [
            _hoisted_4,
            _createTextVNode(_toDisplayString(_ctx.$t('campaignContent')), 1)
          ]),
          _createVNode(_component_alert_info, {
            "can-use-html": "",
            description: _ctx.$t('descriptionReservationCampaignContent'),
            description2: _ctx.$t('descriptionReservationCampaignContent2')
          }, null, 8, ["description", "description2"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_input_text, {
              modelValue: _ctx.reservationCampaignContent.title,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.reservationCampaignContent.title) = $event)),
              modelModifiers: { trim: true },
              label: _ctx.$t('title'),
              name: "title",
              rules: "max:100",
              errors: errors
            }, null, 8, ["modelValue", "label", "errors"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_ctx.$can('use-feature', 'ORCA_WEBSITE_INTEGRATION'))
              ? (_openBlock(), _createBlock(_component_input_text, {
                  key: 0,
                  modelValue: _ctx.reservationCampaignContent.menu_label,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.reservationCampaignContent.menu_label) = $event)),
                  modelModifiers: { trim: true },
                  label: _ctx.$t('menuText'),
                  name: "$t('menuText')",
                  rules: "max:100",
                  errors: errors
                }, null, 8, ["modelValue", "label", "errors"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("h3", _hoisted_8, [
          _hoisted_9,
          _createTextVNode(_toDisplayString(_ctx.$t('contentReservationPeriodBefore')), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_input_text_editor, {
              modelValue: _ctx.reservationCampaignContent.description_before,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.reservationCampaignContent.description_before) = $event)),
              mode: "basic",
              height: 200,
              label: _ctx.$t('shortExplanation'),
              name: _ctx.$t('contentReservationPeriodBefore'),
              rules: (_ctx.reservationCampaign.begin_date) ? 'required' : '',
              errors: errors
            }, null, 8, ["modelValue", "label", "name", "rules", "errors"])
          ])
        ]),
        _createElementVNode("h3", _hoisted_12, [
          _hoisted_13,
          _createTextVNode(_toDisplayString(_ctx.$t('contentReservationPeriodDuring')), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_input_text_editor, {
              modelValue: _ctx.reservationCampaignContent.description_during,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.reservationCampaignContent.description_during) = $event)),
              mode: "basic",
              height: 200,
              label: _ctx.$t('shortExplanation'),
              name: _ctx.$t('contentReservationPeriodDuring'),
              rules: "required",
              errors: errors
            }, null, 8, ["modelValue", "label", "name", "errors"])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_input_text_editor, {
              modelValue: _ctx.reservationCampaignContent.remark_description,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.reservationCampaignContent.remark_description) = $event)),
              mode: "basic",
              height: 200,
              label: _ctx.$t('remark'),
              name: _ctx.$t('remark'),
              errors: errors
            }, null, 8, ["modelValue", "label", "name", "errors"])
          ])
        ]),
        _createElementVNode("h3", _hoisted_17, [
          _hoisted_18,
          _createTextVNode(_toDisplayString(_ctx.$t('contentReservationPeriodAfter')), 1)
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_input_text_editor, {
              modelValue: _ctx.reservationCampaignContent.description_after,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.reservationCampaignContent.description_after) = $event)),
              mode: "basic",
              height: 200,
              label: _ctx.$t('shortExplanation'),
              name: _ctx.$t('contentReservationPeriodAfter'),
              rules: (_ctx.reservationCampaign.end_date) ? 'required' : '',
              errors: errors
            }, null, 8, ["modelValue", "label", "name", "rules", "errors"])
          ])
        ]),
        _createElementVNode("h3", _hoisted_21, [
          _hoisted_22,
          _createTextVNode(_toDisplayString(_ctx.$t('extensiveExplanation')), 1)
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_input_text_editor, {
              modelValue: _ctx.reservationCampaignContent.extensive_explanation,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.reservationCampaignContent.extensive_explanation) = $event)),
              mode: "editor",
              name: _ctx.$t('extensiveExplanation'),
              errors: errors
            }, null, 8, ["modelValue", "name", "errors"])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("h3", _hoisted_26, [
            _hoisted_27,
            _createTextVNode(_toDisplayString(_ctx.$t('externalAgenda')), 1)
          ]),
          _createVNode(_component_alert_info, {
            "can-use-html": "",
            description: _ctx.$t('descriptionReservationCampaignAgenda'),
            description2: _ctx.$t('descriptionReservationCampaignAgenda2')
          }, null, 8, ["description", "description2"])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createVNode(_component_input_text_editor, {
              modelValue: _ctx.reservationCampaignContent.ext_agenda_email_notifications_description,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.reservationCampaignContent.ext_agenda_email_notifications_description) = $event)),
              mode: "basic",
              height: 200,
              label: _ctx.$t('externalAgendaEmailNotification'),
              name: _ctx.$t('externalAgendaEmailNotification'),
              errors: errors
            }, null, 8, ["modelValue", "label", "name", "errors"])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createVNode(_component_input_text_editor, {
              modelValue: _ctx.reservationCampaignContent.ext_agenda_sms_notifications_description,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.reservationCampaignContent.ext_agenda_sms_notifications_description) = $event)),
              mode: "bare",
              height: 200,
              label: _ctx.$t('externalAgendaSmsNotification'),
              name: _ctx.$t('externalAgendaSmsNotification'),
              errors: errors
            }, null, 8, ["modelValue", "label", "name", "errors"])
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createVNode(_component_input_url, {
              modelValue: _ctx.reservationCampaignContent.ext_agenda_url,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.reservationCampaignContent.ext_agenda_url) = $event)),
              placeholder: "https://www.mijnapotheek.be",
              label: _ctx.$t('externalAgendaUrl'),
              name: "url",
              rules: "max:2000",
              errors: errors
            }, null, 8, ["modelValue", "label", "errors"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("button", _hoisted_34, [
          _createTextVNode(_toDisplayString(_ctx.$t('save')) + " ", 1),
          (_ctx.isSubmitting)
            ? (_openBlock(), _createElementBlock("span", _hoisted_35))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_router_link, {
          to: {name: 'reservation-campaigns'},
          class: "btn btn-outline-primary ms-3"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('cancel')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["onSubmit"]))
}